export enum LocationUpdateStatus {
    None = 0,
    InitialZone = 1,
    ZoneChanged = 2,
    StillAtZone = 3,
    ZoneChangedWithTimeout = 4,
    SourceChanged = 5
}

export class TagLocationModel {
    
    accessHistoryId?: string;
    tagSessionHistoryId: string;
    previousZoneId?: string;
    currentZoneId: string;
    previousLocationNodeId?: string;
    currentLocationNodeId: string;
    currentLocationName: string;
    currentLocationPath: string;
    currentReaderAntennaId: string;
    longitude: number | null;
    latitude: number | null;
    zoneDuration: number;
    zoneChangeDuration: number;
    distance: number;
    firstSeen: Date;
    lastSeen: Date;
    trackerDataSource: number;
    locationUpdateStatus: LocationUpdateStatus;
    accessRuleId?: string;
    permission?: number;
    alert?: number;
    
    constructor(data?: any) {
        if (data) {
            Object.assign(this, data);
            this.firstSeen = new Date(data.firstSeen);
            this.lastSeen = new Date(data.lastSeen);
            this.latitude = this.parseCoordinate(data.latitude);
            this.longitude = this.parseCoordinate(data.longitude);
        }
    }

    private parseCoordinate(value: any): number | null {
        if (value === null || value === undefined || value === '') {
            return null;
        }

        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }
}
